import React, { useEffect } from "react";

/**
 * Renders one or more TikTok posts via TikTok's official oEmbed script.
 * `urls` is an array of full TikTok video URLs.
 */
export default function TikTokFeed({ urls = [] }) {
  useEffect(() => {
    if (urls.length === 0) return;
    // Inject the TikTok embed script once
    if (!document.querySelector('script[src="https://www.tiktok.com/embed.js"]')) {
      const s = document.createElement("script");
      s.src = "https://www.tiktok.com/embed.js";
      s.async = true;
      document.body.appendChild(s);
    } else if (window.tiktokEmbed?.load) {
      window.tiktokEmbed.load();
    }
  }, [urls.length]);

  if (!urls || urls.length === 0) return null;

  const idOf = (url) => {
    const m = (url || "").match(/\/video\/(\d+)/);
    return m ? m[1] : "";
  };

  return (
    <section className="mx-auto max-w-[1400px] px-6 py-24 lg:px-10">
      <div className="font-label text-xs text-[#FFC900]">/ #VAPEESSENCE ON TIKTOK</div>
      <h2 className="mt-3 font-display text-4xl font-black tracking-tighter lg:text-5xl">
        Fresh <span className="text-[#FF5A1F]">drops</span> on our feed.
      </h2>
      <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {urls.slice(0, 6).map((url) => {
          const id = idOf(url);
          if (!id) return null;
          return (
            <div key={url} className="border border-white/10 bg-[#0d0d0d] overflow-hidden">
              <blockquote
                className="tiktok-embed"
                cite={url}
                data-video-id={id}
                style={{ maxWidth: "605px", minWidth: "260px" }}
              >
                <section />
              </blockquote>
            </div>
          );
        })}
      </div>
    </section>
  );
}
